import { ShimmerTwoCol } from "./DashboardShimmer";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const MonitorIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);

const AvgCard = ({ title, rows }) => (
  <DashboardCard title={title} icon={<MonitorIcon />}>
    {rows.map((r, i) => (
      <div key={i} className="db-avg-row">
        <span>{r.label}</span>
        <span className="db-avg-val">{r.value}{r.unit}</span>
      </div>
    ))}
  </DashboardCard>
);

const AverageWeights = ({ data , isLoading = false }) => {
  

 
  const pallet_metrics =  [
    { 
      label: "Avg pallet wt paid",
      key:"avg_pallet_weight_paid",
      value : data?.pallet_averages?.avg_pallet_weight_paid ?? 0 ,
      unit : "kg"
    },
    { 
      label: "Avg orange pallet wt",
      key: "avg_orange_pallet_weight",
      value : data?.pallet_averages?.avg_orange_pallet_weight ?? 0,
      unit : "kg"
    },
    { 
      label: "Avg Pallet After Ripen",
      key : "avg_pallet_weight_after_ripening",
      value : data?.pallet_averages?.avg_pallet_weight_after_ripening ?? 0,
      unit : "kg"
    },
    { 
      label: "Pallet Weight Enter Processing (Peeler Case)",
      key: "pallet_weight_in_processing",
      value : data?.pallet_averages?.pallet_weight_in_processing ?? 0,
      unit : "kg"
    },
  ];

  const case_metrics = [
    { 
      label: "Avg case wt paid",
      key: "avg_case_weight_paid",
      value : data?.case_averages?.avg_case_weight_paid ?? 0,
      unit : "kg"
    },
    { 
      label: "Avg case pallet wt",
      key: "avg_case_pallet_weight",
      value : data?.case_averages?.avg_case_pallet_weight ?? 0 ,
      unit : "kg"
    },
    { 
      label: "Avg case After Ripen",
      key: "avg_case_weight_after_ripening",
      value : data?.case_averages?.avg_case_weight_after_ripening ?? 0 ,
      unit : "kg"
    },
    { 
      label: "Avg Peeler case wt",
      key: "avg_peeler_case_weight",
      value : data?.case_averages?.avg_peeler_case_weight ?? 0 ,
      unit : "kg"
    },
  ];

  return (
    <div>
      <div className="internal-section-title">
        <span className="db-title-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="5" r="3"/><path d="M6.5 8a2 2 0 0 0-1.905 1.46L2 17h20l-2.595-7.54A2 2 0 0 0 17.5 8z"/><line x1="12" y1="8" x2="12" y2="17"/>
          </svg>
        </span>
        Average Weights
      </div>
      {isLoading ? (
        <ShimmerTwoCol />
      ) : (
        <div className="db-two-col">
          <AvgCard title="Pallet Averages" rows={pallet_metrics} />
          <AvgCard title="Case Averages"   rows={case_metrics}   />
        </div>
      )}
    </div>
  )
};

export default AverageWeights;
